import React from 'react';
import { MapPin } from 'lucide-react';

const ServiceAreasComponent = ({ config = {} }) => {
  const primaryColor = 'var(--theme-primary)';
  
  const title = config.title || 'Serving Your Community';
  const subtitle = config.subtitle || 'We proudly provide services to families across:';
  const areas = config.areas || ['Chantilly', 'South Riding', 'Aldie', 'Ashburn', 'Centreville', 'Reston', 'Herndon'];

  return (
    <section className="bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-xl font-bold text-gray-900 mb-4">{title}</h2>
        {subtitle && (
          <p className="text-gray-600 mb-6" style={{ fontSize: '1rem' }}>{subtitle}</p>
        )}
        
        <div className="flex flex-wrap justify-center gap-3">
          {areas.map((area, index) => (
            <span
              key={index}
              className="inline-flex items-center px-4 py-2 rounded-full text-white font-medium text-sm"
              style={{ backgroundColor: primaryColor }}
            >
              <MapPin className="h-4 w-4 mr-1.5" />
              {area}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasComponent;
